import { SearchResultsListingsGridQuery_searchResults_SearchResults_listings_SearchListing_trackingContext_TrackingContext_card_TrackingCard } from '../../contexts/search-results-context/query/__generated__/search-results-listings.fed.query'
import { Card100 } from '@at/track-types'

export const card = (
    trackingCard: SearchResultsListingsGridQuery_searchResults_SearchResults_listings_SearchListing_trackingContext_TrackingContext_card_TrackingCard
): Card100 => {
    return {
        SCHEMA_KEY: 'Card100',
        category: trackingCard.category,
        sub_category: trackingCard.subCategory || undefined,
    }
}
